module.exports = __WEBPACK_EXTERNAL_MODULE_285__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/display/DisplayObjectContainer","root":["openfl","display","DisplayObjectContainer"],"commonjs":"openfl/display/DisplayObjectContainer","commonjs2":"openfl/display/DisplayObjectContainer"}
// module id = 285
// module chunks = 0